// extracted by mini-css-extract-plugin
export default {"content":"EmailQueueTable_content__BF9zF","emptyContainer":"EmailQueueTable_emptyContainer__5Q4+E","actionColumnTitle":"EmailQueueTable_actionColumnTitle__2oUEj"};